module.exports = __webpack_public_path__ + "static/media/chart-line-secondary4.5e64fb3f.svg";